<template>
	<el-form-item
		v-if="generalMethods.valueExist(prop)"
		:label="hideLabel ? null : generalMethods.translate(label)"
		:for="id == null ? prop : id"
		:prop="prop"
		:rules="rules"
		:class="`${elFormItemClassses}`"
		label-width="100px"
		:required="required"
	>
		<SelectCore
			:id="id == null ? prop : id"
			v-model="localModelValue"
			:options="options"
			:optionEnglishArabicName="optionEnglishArabicName"
			:value-key="valueKey"
			@change="(value) => emitEvent('change', value)"
			:disabled="disabled"
			:readonly="readonly"
			:placeholder="generalMethods.translate(placeholder)"
			:size="size"
			:teleported="false"
			:class="elClasses"
			:clearable="clearable"
			:multiple="multiple"
		/>
	</el-form-item>
	<SelectCore
		v-else
		:id="id == null ? prop : id"
		v-model="localModelValue"
		:options="options"
		:optionEnglishArabicName="optionEnglishArabicName"
		:value-key="valueKey"
		@change="(value) => emitEvent('change', value)"
		:disabled="disabled"
		:readonly="readonly"
		:placeholder="generalMethods.translate(placeholder)"
		:size="size"
		:teleported="false"
		:class="elClasses"
		:clearable="clearable"
		:multiple="multiple"
	/>
</template>
<script lang="ts">
import { computed, defineComponent } from "vue";

import SelectCore from "@/components/element-plus/SelectCore.vue";

import * as generalMethods from "@/core/mixins/general_methods";
import * as customValidation from "@/core/mixins/custom_validation";

export default defineComponent({
	name: "c-input",
	props: {
		id: { type: String, default: null },
		label: { type: String, default: null },
		prop: { type: String, default: null },
		valueKey: { type: String, default: "id" },
		options: { default: [] },
		optionEnglishArabicName: { type: Boolean, default: false },
		optionLabelKey: { type: String, default: "" },
		optionFunction: { default: null },
		modelValue: {},
		required: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
		readonly: { type: Boolean, default: false },
		extraRules: { type: Array, default: null },
		placeholder: { type: String, default: "select" },
		hideLabel: { type: Boolean, default: false },
		size: { type: String, default: "default" },
		elClasses: { type: String, default: "w-100" },
		elFormItemClassses: { type: String, default: "" },
		clearable: { type: Boolean, default: false },
		multiple: { type: Boolean, default: false },
	},
	components: {
		SelectCore,
	},
	setup(props, { emit }) {
		const localModelValue = computed({
			get() {
				return props.modelValue;
			},
			set(newValue) {
				emit("update:modelValue", newValue);
			},
		});

		const rules = computed(() => {
			let rules = [] as Array<any>;

			if (props.required) {
				rules.push({ required: true, message: generalMethods.getRequiredMessage(props.label) });
			}

			if (props.extraRules != null) {
				rules = rules.concat(props.extraRules);
			}

			return rules;
		});

		const emitEvent = (event, value) => {
			emit(event, value);
		};

		return {
			generalMethods,
			customValidation,

			localModelValue,

			rules,

			emitEvent,
		};
	},
});
</script>
